import * as moment from "moment";

export class DateUtils {
  public static toDDMMYYYY(date: unknown): string {
    if (!date) return "";

    const m = moment(date);

    if (!m.isValid()) return "";

    return m.format("DD-MM-YYYY");
  }

  public static formatStreetViewImageDate(date?: string): string {
    if (!date?.trim()) {
      return "";
    }

    const [year, month] = date.split("-");
    if (month) {
      const formatted = new Date(Number(year), Number(month) - 1).toLocaleDateString("es-MX", {
        month: "long",
        year: "numeric",
      });
      return (formatted.charAt(0).toUpperCase() + formatted.slice(1)).replace(" de ", " ");
    }

    return year;
  }
}
